<template>
    <div v-if="modalactive" class="modal fade show custom-modal-shell" v-bind:style="{'display':'block','z-index':2050}" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-notify custom-modal-dialog" v-bind:class="modal_type" v-bind:style="dialogStyle" role="document">
            <div class="modal-content custom-modal-content">
                <slot name="header"></slot>
                <div class="modal-body">
                    <slot name="body"></slot>
                </div>
                <div class="modal-footer justify-content-center">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
        <div class="modalbg" v-on:click="backClick"></div>
    </div>
</template>
<script>
module.exports = {
    name:'customModalComponent',
    props:{
        url:{
            type:String,
            default:''
        },
        modal_type:{
            type:String,
            default:''
        },
        modalactive:{
            type:Boolean,
            default:false
        },
        backurl:{
            type:String,
            default:''
        },
        init_flag:{
            type:Boolean,
            default:true
        },
        url_params:{
            type:Boolean,
            default:true
        },
        dialog_style:{
            type:Object,
            default:function(){
                return {};
            }
        }
    },
    computed:{
        dialogStyle:function(){
            return Object.assign({maxWidth:'850px'}, this.dialog_style || {});
        }
    },
    methods:{
        backClick: function(){
            this.$emit('outside_click');
        },
        escapeCloser: function(evt){
            if(("key" in evt && (evt.key === "Escape" || evt.key === "Esc")) || evt.keyCode === 27){
                //document.removeEventListener("keydown",escapeCloser);
                this.$emit('outside_click');
            }
        }
    },
    watch:{
        modalactive:function() {
            if(this.url_params) {
                if(this.modalactive) {
                    if(!!(window.history&&history.pushState)) {
                        history.pushState(null,null,this.url)   
                    }
                }
                else {
                    if(this.init_flag) {
                        this.$emit('init_flag',false)
                        if(!!(window.history&&history.pushState)) {
                            history.pushState(null,null,this.backurl)
                        }
                    } else {
                        if(!!(window.history&&history.pushState)) {
                            history.back()    
                        }
                    }
                }
            }
            if(this.modalactive){
                document.addEventListener("keydown",this.escapeCloser,true);
            }
            else{
                document.removeEventListener("keydown",this.escapeCloser,true);
            }
        }
    }
}
</script>
<style scoped>
.custom-modal-shell {
    display: flex !important;
    align-items: center;
    justify-content: center;
    overflow-y: auto;
    padding: 48px 12px;
}

.custom-modal-dialog {
    width: 100%;
    margin: auto;
}

.custom-modal-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-height: min(88vh, calc(100vh - 96px));
    overflow: hidden;
}

.custom-modal-content .modal-body {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
}

.custom-modal-content .modal-footer {
    flex-shrink: 0;
}

.custom-modal-shell .modalbg {
    position: fixed;
    inset: 0;
    width: auto;
    height: auto;
}

@media (max-width: 767px) {
    .custom-modal-shell {
        padding: 24px 8px;
    }

    .custom-modal-content {
        max-height: min(92vh, calc(100vh - 48px));
    }
}
</style>
